import { useLocation } from 'react-router';
import { useGlobalStore } from '../../stores/global-store';
import { selectView, type View } from './view-model';

/** Reactive view for rendering — re-derives on route or override change. */
export function useView(): View {
  const location = useLocation();
  const override = useGlobalStore((s) => s.viewOverride);
  return selectView(location.pathname, location.search, override);
}

/** Non-reactive snapshot for imperative logic (e.g. getResults). */
export function getView(): View {
  const override = useGlobalStore.getState().viewOverride;
  return selectView(window.location.pathname, window.location.search, override);
}

/** Clear the transient view override (if any) — called on every router
 *  navigation (see main.tsx) so an override never outlives the screen it was set
 *  for. No-op when there is no override. */
export function clearViewOverride(): void {
  if (useGlobalStore.getState().viewOverride) {
    useGlobalStore.getState().setViewOverride(null);
  }
}
